import {
  createRepository,
  type PersistenceAdapter,
  type ObjectVcsTypedRepository,
} from "@bjalon/object-vcs-core";
import { firebasePersistence } from "@bjalon/object-vcs-firebase";
import { firestore } from "../lib/firebase";
import {
  FORMATION_CONTENT_DEFAULT_BRANCH,
  FORMATION_CONTENT_GRAPH_VERSION,
  FORMATION_CONTENT_SCHEMA_VERSION,
  formationContentGraph,
  type FormationContentState,
} from "./formationContentGraph";

export const FORMATION_CONTENT_VCS_COLLECTION = "formationContentVcs";
export const FORMATION_CONTENT_CURRENT_PUBLICATION_TAG = "current-publication";

export type FormationContentRepository = ObjectVcsTypedRepository<
  typeof formationContentGraph
>;

export function formationContentRepoId(formationId: string): string {
  return formationId;
}

export function createFormationContentPersistence(): PersistenceAdapter<FormationContentState> {
  if (!firestore) {
    throw new Error("Firebase n'est pas configuré.");
  }

  return firebasePersistence<FormationContentState>({
    db: firestore,
    rootCollection: FORMATION_CONTENT_VCS_COLLECTION,
  });
}

export function createFormationContentRepository(
  formationId: string,
): FormationContentRepository {
  return createRepository({
    defaultBranch: FORMATION_CONTENT_DEFAULT_BRANCH,
    graph: formationContentGraph,
    graphVersion: FORMATION_CONTENT_GRAPH_VERSION,
    persistence: createFormationContentPersistence(),
    repoId: formationContentRepoId(formationId),
    schemaVersion: FORMATION_CONTENT_SCHEMA_VERSION,
  });
}
